const de = {
  metaTitle: "FearGreed — Crypto-Stimmungsknopf",
  metaDescription: "Der Crypto Fear & Greed Index als ein taktiler Knopf. Planmäßige Aktualisierungen von alternative.me. Kein Konto, kein Tracking.",

  navAbout: "Docs",
  footerPrivacy: "Datenschutz",
  footerSupport: "Support",
  footerAbout: "Docs",
  footerDataSource: "Daten: alternative.me · Keine Finanzberatung",

  loading: "Laden…",
  unableToLoad: "Index konnte nicht geladen werden",
  somethingWentWrong: "Etwas ist schiefgelaufen.",
  tryAgain: "Erneut versuchen",
  lastUpdated: "Aktualisiert {time}",
  updating: "Aktualisierung…",
  buttonUpdated: "Aktualisiert ✓",
  nowLabel: "{value} ({bucket})",
  sourceLabel: "Quelle: alternative.me",
  ariaButton: "{value} {bucket} — Fear and Greed Index. Tippen für Insight.",

  ritualDisclaimer: "Keine Finanzberatung",

  infoTitle: "Fear & Greed Index",
  infoDescription: "Krypto-Marktstimmung (0–100). Volatilität, Momentum, Social Media, Umfragen. Quelle: alternative.me. Keine Finanzberatung.",
  infoAttribution: "Daten von alternative.me Crypto Fear & Greed Index.",
  info7d: "7-Tage-Trend",
  info30d: "30-Tage-Trend",
  infoNextUpdate: "Nächstes Update",
  infoInterpretTitle: "So lesen Sie es",
  infoInterpretExtremeFear: "0–24: Extreme Angst. Historisch sind darauf teilweise Erholungen gefolgt.",
  infoInterpretExtremeGreed: "75–100: Extreme Gier. Historisch sind darauf teilweise Korrekturen gefolgt.",
  infoDisclaimer: "Nur Stimmungsindikator. Vergangene Muster sagen keine zukünftigen Ergebnisse voraus. Eigene Recherche durchführen.",
  infoApiTitle: "API",
  infoPulseTitle: "Pulse",
  infoDocsLink: "Vollständige Dokumentation und API-Referenz",

  backToButton: "Zurück",

  aboutTitle: "Docs",
  aboutWhatTitle: "Was ist FearGreed?",
  aboutWhat: "Zeigt den Crypto Fear & Greed Index — einen täglichen Stimmungswert (0–100), berechnet von alternative.me aus Volatilität, Momentum, Social Media, Umfragen, Dominanz und Trends. Ein Signal. Kein Rauschen.",
  aboutWhyTitle: "Warum FearGreed?",
  aboutWhyIntro: "Der Rohindex ist eine Zahl. FearGreed macht daraus ein Produkt.",
  aboutWhy1Title: "Ritualisierte UX",
  aboutWhy1: "Ein taktiler Knopf. Keine Charts, kein Rauschen, keine Dashboards. Tippen, lesen, weitermachen.",
  aboutWhy2Title: "Planmäßige Synchronisation",
  aboutWhy2: "Prüft auf neue Daten über geplante Cron-Fenster, abgestimmt auf den täglichen Aktualisierungszyklus der Quelle.",
  aboutWhy3Title: "Abgeleitete Analysen",
  aboutWhy3: "Delta, gleitende Durchschnitte, Steigung, Regimendauer, Warnlabels — berechnet aus Rohdaten, nicht von der Quelle verfügbar.",
  aboutWhy4Title: "Pulse in natürlicher Sprache",
  aboutWhy4: "KI-generierter täglicher Insight-Satz. Kontextuell, nicht generisch.",
  aboutWhy5Title: "Market Tape",
  aboutWhy5: "BTC/ETH 24h-Änderungen, Marktkapitalisierung, Dominanz, Volumen und regelbasiertes Drucklabel. Alle 4 Stunden aktualisiert.",
  aboutWhy6Title: "Agentenfreundlich",
  aboutWhy6: "Strukturierte JSON-Endpoints, llms.txt, OpenAPI-Spezifikation und SVG-Badge. Für programmatischen Zugriff gebaut.",
  aboutSourceTitle: "Datenquelle",
  aboutSource: "Daten von alternative.me. Die Quelle wird in der Regel einmal täglich gegen 00:00 UTC aktualisiert. FearGreed prüft neue Daten über geplante Cron-Fenster, die auf diesen Zeitplan abgestimmt sind.",
  aboutApiTitle: "API",
  aboutApiDescription: "Öffentliche Endpoints. CORS aktiviert. JSON sofern nicht anders angegeben. Keine Authentifizierung erforderlich.",
  aboutApiLatest: "Letzter Wert mit abgeleiteten Analysen: Delta, Durchschnitte, Abstand vom Neutralwert.",
  aboutApiHistory: "Letzte 30 Tageswerte mit Bucket und Farbe.",
  aboutApiSummary: "Zusammenfassung im Klartext. Nützlich für LLMs und Agenten.",
  aboutApiBadge: "SVG-Badge. Einbetten in READMEs oder Dashboards.",
  aboutApiContext: "KI-generierter täglicher Kontext mit Trendhinweis und allen abgeleiteten Analysen. Cache 1h.",
  aboutApiPulse: "Strukturierte Analysen: Regime, Warnsignal, Steigung, Durchschnitte. Keine KI. Cache 15min.",
  aboutApiTape: "BTC/ETH 24h-Änderungen, Marktkapitalisierung, Dominanz, Volumen und Drucklabel. Cache 30min.",
  aboutBadgeTitle: "Badge / Statisches Embed",
  aboutBadgeDescription: "Betten Sie den aktuellen Index als SVG-Badge ein:",
  aboutEmbedTitle: "Interaktives Embed",
  aboutEmbedDescription: "Betten Sie den vollständigen interaktiven Button über iframe in jede Seite ein. Gleiches taktiles Gefühl, kein Chrome, nur zwischengespeicherte Daten.",
  aboutCurlTitle: "Beispielanfrage",
  aboutJsonExample: "Beispielantwort (Latest)",
  aboutLlmsTxtTitle: "llms.txt",
  aboutLlmsTxtDescription: "Maschinenlesbares Projektzusammenfassung für LLM-Agenten und Crawler.",
  aboutOpenapiTitle: "OpenAPI",
  aboutOpenapiDescription: "Vollständige API-Spezifikation im OpenAPI 3.0 Format.",
  aboutDisclaimerTitle: "Haftungsausschluss",
  aboutDisclaimer: "Nur Stimmungstool. Sagt keine Preisbewegungen voraus. Keine Finanzberatung. Eigene Recherche durchführen.",
  aboutNonAffiliation: "FearGreed ist eine unabhängige Oberfläche. Es ist weder mit alternative.me verbunden noch von ihnen unterstützt.",
  staleIndicator: "Offline · zwischengespeicherte Daten",
  infoButton: "Weitere Informationen",
  languageSelector: "Sprache",
  themeToggle: "Thema wechseln",

  privacyTitle: "Datenschutzerklärung",
  privacyEffectiveDate: "Gültig ab: 8. März 2026",
  privacySummaryTitle: "Zusammenfassung",
  privacySummary: "FearGreed erfordert keine Anmeldung, erstellt keine Konten und erhebt keine personenbezogenen Daten.",
  privacyDataTitle: "Erhobene Daten",
  privacyData: "Keine. Keine Registrierungen, keine Tracking-Cookies, keine Analyseprofile.",
  privacyTechTitle: "Technische Daten",
  privacyTech: "Die Hosting-Infrastruktur kann IP-Adressen und Zeitstempel für die Zuverlässigkeit protokollieren. Nicht mit einzelnen Benutzern verknüpft.",
  privacyThirdPartyTitle: "Drittanbieterdienste",
  privacyThirdParty: "FearGreed ruft Daten von der alternative.me API ab. Beachten Sie deren Datenschutzerklärung.",
  privacyAdsTitle: "Werbung",
  privacyAds: "FearGreed zeigt keine Werbung an.",
  privacyChangesTitle: "Änderungen",
  privacyChanges: "Aktualisierungen werden auf dieser Seite mit einem aktualisierten Gültigkeitsdatum veröffentlicht.",
  privacyContactTitle: "Kontakt",
  privacyContact: "Fragen? Kontaktieren Sie uns unter",

  supportTitle: "Support",
  supportDescription: "Bei Fragen oder Problemen kontaktieren Sie uns unter:",

  bucketExtremeFear: "Extreme Angst",
  bucketFear: "Angst",
  bucketNeutral: "Neutral",
  bucketGreed: "Gier",
  bucketExtremeGreed: "Extreme Gier",

  pulseLabel: "Pulse:",
  regimeSuffix: "{days}T Regime",
  watchFearDeepening: "Angst vertieft sich",
  watchFearStabilizing: "Angst stabilisiert sich",
  watchNeutralCompression: "Neutrale Kompression",
  watchGreedAccelerating: "Gier beschleunigt",
  watchGreedOverheating: "Gier überhitzt",
  watchPossibleReversal: "Mögliche Umkehr",
  watchTrendPersistence: "Trend hält an",
  watchRecoveryBuilding: "Erholung im Aufbau",

  infoRegimePulse: "Regime & Pulse",
  infoMarketTape: "Market Tape",
  infoPressure: "Druck",

  updateAvailable: "Update verfügbar",

  aboutViewLlmsTxt: "llms.txt ansehen",
  aboutViewOpenapi: "openapi.json ansehen",

  // Market pressure labels
  pressureBroadSellOff: "Breiter Ausverkauf",
  pressureUnderPressure: "Unter Druck",
  pressureBroadRally: "Breite Rally",
  pressureRiskAppetite: "Risikobereitschaft steigt",
  pressureFlat: "Markt flach",
  pressureMixed: "Gemischte Signale",

  notFoundTitle: "Seite nicht gefunden",
  notFoundBack: "Zurück zur Startseite",

  hintTap: "drück mich",
} as const;

export default de;
